module.exports = __webpack_public_path__ + "static/media/Lato-Regular.544d9697.ttf";